import React from 'react'
import Nav from '../Navigation/Nav'
import Hostinghome from './Hostinghome'

const Hero = () => {
  return (
    <div className='lg:h-[100vh] bg-[#06000A] flex flex-col lg:px-[8%] px-[4%] relative z-[500]'>
      <Nav />
      <Hostinghome />
    </div>
  )
}

export default Hero